<template>
  <div id="app">
    <router-view />
    <testDialog />
    <allDialog />
  </div>
</template>

<script>
import testDialog from "./components/easy-point/point-add";
import allDialog from "./components/dialog";
export default {
  name: "App",
  components: {
    testDialog,
    allDialog,
  },
  data() {
    return {};
  },
  destroyed() {
  },
  mounted() {
    let url = window.location.host;
    console.log("IP地址：", url);
    if (url === '222.128.47.96:16001') {
      // 外网
      localStorage.setItem("ip", "__HOST__");
    } else {
      // 内网
      localStorage.setItem("ip", "SECOND_HOST");
    }
    /* let ipConfig =
      /^(127\.0\.0\.1)|(localhost)|(10\.\d{1,3}\.\d{1,3}\.\d{1,3})|(172\.((1[6-9])|(2\d)|(3[01]))\.\d{1,3}\.\d{1,3})|(192\.168\.\d{1,3}\.\d{1,3})$/;
    let a = ipConfig.test(url);
    if (a) {
      // 内网
      localStorage.setItem("ip", "SECOND_HOST");
    } else {
      // 外网
      localStorage.setItem("ip", "__HOST__");
    } */
  },
  methods: {},
};
</script>

<style>
/* @import './App.scss';
@import './style/main.scss'; */
@import "./style/css/element-table.css";

html,
body {
  height: 100%;
  color: #333;
  margin: 0 0;
  padding: 0 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-background-size: 100% 100%;
  /* text-align: center; */
  color: #2c3e50;
  height: 100%;
  /* overflow: hidden; */
  /* margin-top: 60px; */
}

.content {
  flex: 1;
  padding-left: 16px;
  padding-right: 16px;
  /* padding-top: 16px; */
  padding-bottom: 16px;
  height: calc(100vh - 72px);
  overflow: auto;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  width: 8px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 2px rgba(197, 197, 197, 0.1);
  background-color: rgba(149, 149, 151, 0.744);
}

.personality-form {
  background-color: #303235;
}

.el-pagination {
  color: #b4b4b4 !important;
  background-color: transparent !important;
}

.el-pager li {
  background-color: transparent !important;
  color: #fff !important;
}

.el-pagination .btn-next,
.el-pagination .btn-prev {
  background: transparent !important;
  color: white !important;
}

.el-pagination .btn-prev {
  background: transparent !important;
  color: white !important;
}

.el-pagination button:disabled {
  background: transparent !important;
}

.el-pager li.active {
  color: #000000 !important;
}

.el-notification {
  height: 29px !important;
  background-color: transparent !important;
  color: #fbfbfb !important;
  border: 1px solid transparent !important;
  padding: 1px 11px 3px 15px !important;
}

.el-notification__content {
  color: #d2cace !important;
  line-height: 12px !important;
}

.el-notification__closeBtn {
  top: 8px !important;
  right: 10px !important;
}

.gs-modal-content {
  background-color: rgba(64, 64, 64, 0.93) !important;
  color: #d2d2d2 !important;
  border: 1px solid rgba(64, 64, 64, 0.13) !important;
}

.gs-modal {
  background-color: rgba(64, 64, 64, 0.93) !important;
}

.gs-modal-body {
  margin-top: 10px !important;
  max-height: 800px !important;
}

.gs-icon-close {
  color: white;
}

.gs-tabs-item {
  color: white !important;
}

.gs-input {
  border: 1px solid #727474 !important;
}

.gs-input-inner {
  background-color: rgba(101, 101, 101, 0.67) !important;
  color: white !important;
}

.gs-tabs-content {
  padding: 16px 10px !important;
}

.gs-button {
  border: 1px solid #7d7d7d !important;
  line-height: 21px !important;
}

.gs-button-primary {
  background-color: transparent !important;
  line-height: 21px !important;
}

.gs-button.gs-button-text {
  border: 1px solid transparent !important;
  padding: 0px !important;
}

.gs-button.gs-button-text:hover {
  border: 1px solid transparent !important;
}

.gs-button:hover,
.tabs-title:hover {
  color: #ff7f00 !important;
}

.gs-tabs-item.is-active {
  color: #ff7f00 !important;
}

.gs-tabs-active-bar {
  background-color: #ff7f00 !important;
}

.gs-tabs-item:hover {
  color: #ff7f00 !important;
}

.gs-button-primary:hover {
  color: #ff7f00 !important;
}

.gs-button-primary:hover,
.gs-tabs-item:hover {
  color: #ff7f00 !important;
}

.tabs li .tabs-inner {
  height: auto;
  border-style: none;
}

.tabs-container {
  width: 100% !important;
}

.tabs li.tabs-selected .tabs-inner {
  color: #c2c2c2;
}

.tabs {
  border-width: 0 0px 0px 0;
}

.tabs li a.tabs-close {
  background: no-repeat -34px center;
}

.tabs-title {
  font-size: 13px;
  font-weight: 500;
  color: #e7e0e1;
}

.tabs-title:hover {
  color: #404040;
}

.tabs-header-bottom .tabs li.tabs-selected .tabs-inner,
.tabs li.tabs-selected .tabs-inner {
  background: #2f2f27;
  border: 1px solid #525659;
}

.gs-checkbox-label {
  color: #e7e0e1;
}

.gs-input-number.is-disabled .gs-input-inner,
.gs-input.is-disabled .gs-input-inner {
  background-color: transparent;
}

.gs-select-wrap {
  background-color: transparent !important;
  border: 1px solid #787477 !important;
  min-height: 26px !important;
}

.gs-select-wrap.is-focus:not(.is-disabled),
.gs-select-wrap:hover:not(.is-disabled) {
  border-color: #7b797b !important;
  box-shadow: 0 0 0 2px #3f3c3e !important;
}

.gs-select-menu-item:hover:not(.is-disabled) {
  background-color: #5d5d5d !important;
}

.gs-popover {
  background-color: rgba(111, 111, 111, 0.94) !important;
}

.gs-select-menu-item.is-selected {
  background-color: transparent !important;
}

.gs-button-default {
  background-color: transparent !important;
  color: #ffffff;
}

.gs-button.is-disabled.gs-button-default,
.gs-button.is-disabled.gs-button-primary {
  background-color: rgba(136, 136, 136, 0.42);
  color: #fffefe;
}

.gs-select-menu-item-label {
  color: #f9f9f9 !important;
}

.gs-select-wrap.is-disabled,
.gs-select-wrap.is-disabled .gs-select-input-value {
  background-color: transparent !important;
}

.el-textarea__inner {
  background-color: transparent !important;
  border: 1px solid #7d7d7d !important;
  color: #ffffffe4 !important;
  font-size: 12px !important;
}

.el-input__inner {
  background-color: transparent !important;
  border: 1px solid #6b6a6a !important;
}

.el-input-number__increase {
  background-color: transparent !important;
}

.el-input-number__decrease {
  background-color: transparent !important;
}

.el-icon-arrow-down {
  color: white !important;
}

.el-icon-arrow-up {
  color: white !important;
}

.el-button--primary.is-plain {
  background-color: transparent !important;
  color: whitesmoke !important;
}

.el-radio__label {
  color: #b8b8b8 !important;
}

.gs-table {
  background-color: #383838 !important;
}

.gs-table tr {
  background-color: transparent !important;
}

.el-table .el-table__cell.gutter {
  background-color: transparent !important;
}

.gs-table tr,
.gs-table tr gs-table-row--striped {
  background-color: transparent !important;
}

.gs-table-header {
  background-color: transparent !important;
}

.gs-table-footer-wrapper thead div,
.gs-table-header-wrapper thead div {
  color: #cecece;
}

.gs-modal-header {
  color: #c8cccf;
  border-bottom: 1px solid #7e7e7e !important;
}

.gs-tabs-item {
  color: #c8cccf !important;
}

.gs-tabs-header {
  border-bottom: 1px solid #7e7e7e !important;
}

fieldset {
  border: 1px solid #797d80 !important;
}

.form-item-objectSeries {
  border: 1px solid #797d80 !important;
}

.menu {
  background-color: #525659 !important;
  color: #bdbdbd !important;
  border: 2px solid #6d7174 !important;
  box-shadow: 2px 2px 3px #6d7174 !important;
}

.menu-shadow {
  box-shadow: 2px 2px 3px #6d7174 !important;
}

.menu-sep {
  border-bottom: 1px solid #4b4f52 !important;
}

.menu-line {
  border-right: 1px solid #4b4f52 !important;
}

.menu-active {
  background-color: #8a8a8a !important;
}

.tabs-header-bottom .tabs li.tabs-selected .tabs-inner,
.tabs li.tabs-selected .tabs-inner {
  background: #2f2f27 !important;
}

.tabs-header-narrow,
.tabs-header-narrow .tabs-narrow {
  background-color: #2f2f27 !important;
}

.tabs-header-bottom .tabs-narrow li.tabs-last,
.tabs-narrow li.tabs-last {
  background-color: #2f2f27 !important;
}

.gs-input-number.is-focus,
.gs-input.is-focus {
  box-shadow: 0 0 0 1px #a7a8a6 !important;
}

.gs-button:hover {
  border-color: #ff7f00 !important;
  color: #ff7f00 !important;
}

.tabs-title:hover {
  color: #eaeaea !important;
}

.el-tree-node:focus>.el-tree-node__content {
  color: #eb910a !important;
}

.gs-input,
.gs-input-number {
  border: 1px solid rgb(124, 123, 123) !important;
}

.gs-input-number .gs-input-number-add,
.gs-input-number .gs-input-number-cut {
  border-left: 1px solid rgb(124, 123, 123) !important;
}

.gs-input-number .gs-input-number-add {
  border-bottom: 1px solid rgb(124, 123, 123) !important;
}

.gs-input-number-add::before {
  color: white !important;
}

.gs-input-number .gs-input-number-add:active,
.gs-input-number .gs-input-number-cut:active {
  background-color: transparent;
}

.el-form-item__label {
  color: #ffffff !important;
  font-size: 12px;
}

.el-button--mini,
.el-button--mini.is-round {
  padding: 5px 13px !important;
  padding-top: 5px !important;
  background-color: transparent !important;
  color: #b4b2b2 !important;
  border: 1px solid rgb(146, 143, 143) !important;
}

.el-button--mini,
.el-button--small {
  font-size: 13px !important;
}

.gs-form-small .gs-form-item {
  margin-bottom: 4px !important;
}

.gs-input,
.gs-input-number {
  height: 20px !important;
}

.gs-input-inner {
  height: 18px !important;
}

.form-item-objectSeries,
fieldset {
  border: 1px solid #4d4f5086 !important;
}

.gs-input-number.is-focus,
.gs-input.is-focus {
  box-shadow: 0 0 0 0px #a7a8a6 !important;
  border: 1px solid rgb(245, 245, 245) !important;
}

.el-button:focus,
.el-button:hover {
  color: rgb(253, 105, 7) !important;
  background-color: transparent !important;
  border-color: #8f8d8d !important;
}

.gs-input-icon,
.gs-input-preicon {
  line-height: 19px !important;
}

.gs-loading.has-mask {
  background-color: #0000007a !important;
}

.el-tabs__item {
  height: 29px;
  line-height: 29px;
  color: #b8b8b8;
}

.gs-tabs-card .gs-tabs-item.is-active {
  border: 1px solid transparent !important;
}

.vjContextMenu {
  z-index: 100000 !important;
}

.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #303235 !important;
  color: #eb910a !important;
}

.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content:hover {
  background-color: #40444c !important;
}

.el-picker-panel {
  z-index: 1000000 !important;
  color: #ffffff !important;
}

.el-input--mini .el-input__inner {
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue